import { matchPath, Outlet, useLocation } from 'react-router-dom';
import { RoutePermissionConfig, RoutePermissionsMap } from '@lp/core/routing/guards/types';
import { PermissionGuard } from './PermissionGuard';

export const findRoutePermissions = (
  permissionsMap: RoutePermissionsMap,
  pathname: string,
): RoutePermissionConfig | undefined => {
  const entry = Object.entries(permissionsMap).find(([pattern]) => matchPath(pattern, pathname));
  return entry?.[1];
};

type AutoGuardedOutletProps = {
  permissionsMap?: RoutePermissionsMap;
};

export const AutoGuardedOutlet = ({ permissionsMap = {} }: AutoGuardedOutletProps) => {
  const location = useLocation();
  const permissionConfig = findRoutePermissions(permissionsMap, location.pathname);

  return (
    <PermissionGuard
      enabled={!!permissionConfig}
      permissions={permissionConfig?.permissions}
      mode={permissionConfig?.mode}
      redirectTo={permissionConfig?.redirectTo}
    >
      <Outlet />
    </PermissionGuard>
  );
};
